import { useEffect, useRef, useState } from 'react';

export const useInView = (
  options: {
    threshold?: number;
    root?: Element | null;
    rootMargin?: string;
    once?: boolean;
  } = {}
) => {
  const {
    threshold = 0, // number between 0 and 1 indicating the percentage of the target visibility.
    root = null, //  element that is used as the viewport for checking visibility.
    rootMargin = '0px', // margin around the root 'top  right  bottom  left'.
    once = true, //to trigger the in view state only once or every time the element enters the viewport.
  } = options;

  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const inView = entry.isIntersecting;

        if (inView) {
          setIsInView(true);
          if (once) observer.disconnect();
        } else if (!once) {
          setIsInView(false);
        }
      },
      { threshold, root, rootMargin }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [threshold, root, rootMargin, once]);

  return { ref, isInView };
};
